/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useEffect } from "react";

import ListPlans from "./files/ListSubscription";
import LisSubscriptiopWrap from "./files/LisSubscriptiopWrap";
import { useParams, Routes, Route, Outlet, Navigate } from "react-router-dom";
import SubscriptionDetailsPage from "./files/SubscribeModal";
const SubscriptionPage = () => {
  const { id } = useParams(); 
  useEffect(() => {
    if (id && id !== "default") {
      localStorage.setItem("userId", id); // Store `id` in localStorage
    } else {
      localStorage.removeItem("userId"); // Remove if no valid `id`
    }
  }, [id]);
  return (
    <div>
 
      <LisSubscriptiopWrap /> 
    
    </div>
  );
};

export default SubscriptionPage;
